import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {withRouter} from 'react-router-dom';
import {injectIntl, FormattedMessage} from 'react-intl';
import CustomScrollDiv from '../../../forecast-app/shared/components/scroll-bars/custom_scroll_div';
import ActivateSageIntacct from '../../../mutations/activate_sage_intacct_mutation';
import DeactivateSageIntacct from '../../../mutations/deactivate_sage_intacct_mutation';
import StartSageIntacctRecipes from '../../../mutations/start_sage_intacct_recipes_mutation';
import StopSageIntacctRecipes from '../../../mutations/stop_sage_intacct_recipes_mutation';
import Util from '../../../forecast-app/shared/util/util';
import {buildHeaderBar} from '../../../forecast-app/shared/components/headers/header-bar/header_bar';
import {createToast} from '../../../forecast-app/shared/components/toasts/another-toast/toaster';
import {ELEMENT_TYPE} from '../../../constants';
import sageIntacctLogo from '../../../images/integrations/sage-intacct/sage-logo.png';

class appSageIntacct extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activating: false,
			deactivating: false,
		};
	}

	componentDidMount() {
		// The Workato embedded iframe sends messages when a connecion is updated.
		// We listen to these to stop/start recipes.
		window.addEventListener('message', this.connectionUpdate);
	}

	componentWillUnmount() {
		window.removeEventListener('message', this.connectionUpdate);
	}

	disableSageIntacct() {
		this.setState({deactivating: true});

		const onSuccess = data => {
			if (data.deactivateSageIntacct.outcome !== 'Success') {
				this.setState({deactivating: false});
				createToast({duration: 10000, message: 'An error occured. Please try again'});
			} else {
				this.setState({deactivating: false});
			}
		};

		Util.CommitMutation(DeactivateSageIntacct, null, onSuccess);
	}

	enableSageIntacct() {
		this.setState({activating: true});

		const onSuccess = data => {
			if (data.activateSageIntacct.outcome !== 'Success') {
				this.setState({activating: false});
				createToast({duration: 10000, message: 'An error occured. Please try again'});
			} else {
				this.setState({activating: false});
			}
		};

		Util.CommitMutation(ActivateSageIntacct, null, onSuccess);
	}

	connectionUpdate(e) {
		let data;

		// Sometimes a string is returned...
		if (typeof e.data === 'string' || e.data instanceof String) {
			// Just in case the string can not be parsed
			try {
				data = JSON.parse(e.data);
			} catch (e) {
				// Do nothing
			}
		} else {
			data = e.data;
		}

		if (data?.type === 'connectionStatusChange') {
			if (data.payload?.connected) {
				const onSuccess = data => {
					if (data.startSageIntacctRecipes.outcome === 'Success') {
						createToast({duration: 10000, message: 'Connection enabled'});
					}
				};

				Util.CommitMutation(StartSageIntacctRecipes, null, onSuccess);
			} else if (!data.payload?.connected) {
				const onSuccess = data => {
					if (data.stopSageIntacctRecipes.outcome === 'Success') {
						createToast({duration: 10000, message: 'Connection disabled'});
					}
				};

				Util.CommitMutation(StopSageIntacctRecipes, null, onSuccess);
			}
		}
	}

	openHelpCenter() {
		// TO DO
	}

	getHeader() {
		const leftContent = [],
			rightContent = [];

		leftContent.push({type: ELEMENT_TYPE.BACK_BUTTON, onClick: this.props.history.goBack});

		return buildHeaderBar(leftContent, rightContent);
	}

	render() {
		const {formatMessage} = this.props.intl;
		return (
			<div className="section-content settings-app settings-app-page">
				{this.props.children}
				{this.getHeader()}
				<CustomScrollDiv>
					<div className="section-body">
						<div className="inner">
							<fieldset className="general">
								<div className="header-wrapper">
									<img height={100} alt="sageIntacct logo" src={sageIntacctLogo} />
									<div style={{marginTop: '20px'}} className="title-description-wrapper">
										<div className="description">
											{formatMessage({id: 'settings.app_catalog.sage_intacct.description'})}
										</div>
									</div>
								</div>

								<div className="qb-buttons">
									{this.props.viewer.company.sageIntacctEnabled ? (
										<button className="submit-button" onClick={this.disableSageIntacct.bind(this)}>
											{!this.state.deactivating
												? formatMessage({id: 'integration.disable'})
												: 'Deactivating...'}
										</button>
									) : (
										[
											<button
												className="submit-button"
												onClick={this.enableSageIntacct.bind(this)}
												key={'connectSageIntacct'}
												disabled={this.state.activating}
											>
												<span>
													{!this.state.activating ? (
														<FormattedMessage id="common.activate" />
													) : (
														'Activating...'
													)}
												</span>
											</button>,
											<button
												className="help-button"
												onClick={this.openHelpCenter.bind(this)}
												key={'helpSageIntacct'}
											>
												<span>
													<FormattedMessage id="settings.app_catalog.help_button" />
												</span>
											</button>,
										]
									)}
								</div>
							</fieldset>

							{this.props.viewer.company.sageIntacctEnabled ? (
								<fieldset className="general">
									<h3>
										<FormattedMessage id="settings.app_catalog.sage_intacct.iframe.title" />
									</h3>
									<p>
										<FormattedMessage id="settings.app_catalog.sage_intacct.iframe.desc" />
									</p>
									<iframe
										title="Workato connection iframes"
										style={{
											width: '1000px',
											height: '770px',
											padding: '20px 20px 20px 0px',
											border: '0',
										}}
										src={`https://app.eu.workato.com/direct_link/embedded/connections/${this.props.viewer.company.workatoSageIntacctConnectionId}?workato_dl_token=${this.props.viewer.company.workatoIframeToken}`}
										allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture;"
										allowFullScreen
									/>
								</fieldset>
							) : null}
						</div>
					</div>
				</CustomScrollDiv>
			</div>
		);
	}
}

const appSageIntacctQuery = graphql`
	query appSageIntacct_Query {
		viewer {
			actualPersonId
			component(name: "app_sage_intacct")
			...appSageIntacct_viewer
		}
	}
`;

export {appSageIntacctQuery};

export default createFragmentContainer(injectIntl(withRouter(appSageIntacct)), {
	viewer: graphql`
		fragment appSageIntacct_viewer on Viewer {
			id
			company {
				id
				sageIntacctEnabled
				workatoCustomerId
				workatoForecastSageIntacctConnectionId
				workatoSageIntacctConnectionId
				workatoIframeToken
			}
		}
	`,
});
